import { AnimatePresence, motion } from 'framer-motion'
import { Row, Text } from '@/components/core'

const IcebreakStartMessage = () => {
  return (
    <AnimatePresence>
      <motion.div
        key="test-start-message"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="mt-10 flex w-full flex-col space-y-10 pb-8"
      >
        <Row className="h-px w-full justify-center bg-white/20">
          <Row className="h-6 items-center justify-center self-center rounded-full bg-electric-indigo-300 px-6">
            <Text.Translated
              transform="uppercase"
              fontWeight="bold"
              className="text-[10px] text-white"
              translationKey="warmup_start_icebreak_start_message"
            />
          </Row>
        </Row>
      </motion.div>
    </AnimatePresence>
  )
}

export default IcebreakStartMessage
